import React from "react";

export interface IFieldLabelProps {
  children: React.ReactNode;
  /** When set, the label renders as a `<label htmlFor>` so screen readers pair it with the input. */
  htmlFor?: string;
  id?: string;
  className?: string;
}

const BASE_CLASSES = "text-sm text-secondary-700 h-[20px]";

export const FieldLabel: React.FC<IFieldLabelProps> = ({ children, htmlFor, id, className }) => {
  const combined = className ? `${BASE_CLASSES} ${className}` : BASE_CLASSES;

  if (htmlFor) {
    return (
      <label id={id} htmlFor={htmlFor} className={combined}>
        {children}
      </label>
    );
  }

  return (
    <span id={id} className={combined}>
      {children}
    </span>
  );
};
